import { css, html, TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";
import { until } from "lit/directives/until.js";
import { Kernel } from "../Kernel";

import "./MainWindow/MainWindow";
import "./LoadingScreen";

@customElement("ds-app")
export class App extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            ds-cave-db-main-window {
                height: 100%;
                width: 100%;
                margin: 0;
                padding: 0;
            }

            ds-loading-screen {
                width: 100%;
                height: 100%;
            }
        `,
    ];

    @property({ type: String }) appTitle: string | undefined;

    private _contents: Promise<TemplateResult> | undefined;

    constructor() {
        super();
    }

    public override async connectedCallback(): Promise<void> {
        super.connectedCallback();
        this._contents = this._init();
    }

    private async _init(): Promise<TemplateResult> {
        return html`<ds-cave-db-main-window .appTitle=${this.appTitle}> </ds-cave-db-main-window>`;
    }

    override render() {
        return html`${until(this._contents, html`<ds-loading-screen></ds-loading-screen>`)}`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-app": App;
    }
}
